/* eslint-disable @typescript-eslint/init-declarations */

import * as React from "react";
import { useSelector } from "react-redux";

import { ConfigurationFeaturesState, CurrentSpaceConfigurationState } from "areas/configuration/reducers/configurationArea";

export enum Feature {
    CommunityActionTemplates,
    MultiTenancy,
    ConfigurationAsCode,
}

interface GlobalConnectedProps {
    features: ConfigurationFeaturesState;
    space: CurrentSpaceConfigurationState;
}

interface FeatureToggleProps {
    feature: Feature;
    enabled?: boolean;
}

export const FeatureToggle: React.FC<FeatureToggleProps & GlobalConnectedProps> = props => {
    let featureStatus: boolean;

    switch (props.feature) {
        case Feature.CommunityActionTemplates:
            featureStatus = props.features.isCommunityActionTemplatesEnabled;
            break;
        case Feature.MultiTenancy:
            featureStatus = props.space ? props.space.isMultiTenancyEnabled : false;
            break;
        case Feature.ConfigurationAsCode:
            featureStatus = props.features.isConfigurationAsCodeEnabled;
            break;
    }

    if ((featureStatus && props.enabled) || (!featureStatus && !props.enabled)) {
        return <span>{props.children}</span>;
    }

    return null;
};

FeatureToggle.defaultProps = { enabled: true };

const ConnectedFeatureToggle: React.FC<FeatureToggleProps> = props => {
    const globalState = useSelector((state: GlobalState) => ({ features: state.configurationArea.features, space: state.configurationArea.currentSpace }));
    return <FeatureToggle {...props} {...globalState} />;
};

export default ConnectedFeatureToggle;
